'use strict';

// Shared public information architecture. Workspace actions stay page-owned.
const links = pairs => pairs.map(([label, href]) => ({ label, href }));
const audiences = links([
  ['Churches and ministries', '/use-cases/churches'], ['Homeschooling', '/use-cases/homeschoolers'],
  ['Independent media', '/use-cases/independent-media'], ['Small business', '/use-cases/small-business'],
  ['Creators', '/use-cases/content-creators'], ['Developers', '/use-cases/developers'],
  ['Cooking', '/use-cases/recipes-cooking'], ['Uncensored chat for free thinkers', '/use-cases/free-thinkers'],
]);
const header = [
  { label:'Product', href:'/features', items:links([
    ['All features','/features'], ['AI chat','/free-ai-chat'], ['Work','/docs/work'],
    ['Images','/features/images'], ['Videos','/features/videos'], ['Music','/features/music'], ['Voice','/voice'],
    ['Files and PDFs','/features/files'], ['Presentations','/features/presentations'],
    ['Spreadsheets','/features/spreadsheets'], ['Documents','/features/documents'],
    ['Memory','/features/memory'], ['Models','/features/models'], ['Bots','/features/agents'], ['Tasks','/features/tasks'],
  ]) },
  { label:'Use cases', href:'/use-cases', items:[...audiences, {label:'All use cases',href:'/use-cases'}] },
  { label:'Resources', href:'/learn', items:links([
    ['Learn','/learn'], ['Documentation','/docs'], ['Blog','/blog'], ['Changelog','/changelog'], ['Download','/download'],
  ]) },
  { label:'Pricing', href:'/pricing' },
  { label:'Developers', href:'/api', items:links([
    ['API overview','/api'], ['API quickstart','/docs/api'], ['Authentication','/docs/api-auth'],
    ['OpenCode setup','/docs/opencode'], ['Pi setup','/docs/pi-cli'], ['Claude Code setup','/docs/claude-code'],
  ]) },
];
const groups = [
  { title:'Product', links:links([
    ['All features','/features'], ['AI chat','/free-ai-chat'], ['Work','/docs/work'],
    ['Images','/features/images'], ['Videos','/features/videos'], ['Music','/features/music'], ['Voice','/voice'],
    ['Files and PDFs','/features/files'], ['Memory','/features/memory'], ['Models','/features/models'],
  ]) },
  { title:'Use cases', links:[...audiences.filter(l=>l.href!=='/use-cases/developers'), {label:'All use cases',href:'/use-cases'}] },
  { title:'Resources', links:links([
    ['Learn','/learn'], ['Documentation','/docs'], ['Blog','/blog'], ['Changelog','/changelog'],
    ['Download','/download'], ['Browser extension','/extension'],
  ]) },
  { title:'Developers', links:links([
    ['API overview','/api'], ['API quickstart','/docs/api'], ['Authentication','/docs/api-auth'],
    ['OpenCode setup','/docs/opencode'], ['Pi setup','/docs/pi-cli'], ['Claude Code setup','/docs/claude-code'],
  ]) },
  { title:'Why Gab AI', links:links([
    ['Conservative AI','/right-wing-ai'], ['Christian AI','/christian-ai'],
    ['ChatGPT alternative','/chatgpt-alternative'], ['Compare alternatives','/alternatives'], ['Import your chats','/switch'],
  ]) },
  { title:'Company', links:links([
    ['About','/about'], ['Pricing','/pricing'], ['Brand','/brand'], ['Contact','/contact'], ['Feedback','/feedback'],
  ]) },
];
const legal = links([
  ['Privacy','/privacy-policy'], ['Terms of Service','/terms-of-service'], ['Terms of Sale','/terms-of-sale'],
  ['Refund policy','/refund-policy'], ['Guidelines','/terms-of-service'], ['DMCA','/dmca'], ['CCPA','/ccpa'],
  ['Affiliate agreement','/affiliate-program-agreement'],
]);
// Dynamic links fail closed on the server until the current published records
// are available. No seed entry or hardcoded candidate confers publication.
function isAvailable(href, available) {
  return !/^\/(?:use-cases|docs|learn|blog)\//.test(href) || !!available?.has(href);
}
function projectNavigation(available) {
  const project = items => items.filter(item=>isAvailable(item.href,available)).map(item=>({...item}));
  return {
    header:header.map(item=>({...item,...(item.items?{items:project(item.items)}:{})})),
    groups:groups.map(group=>({...group,links:project(group.links)})).filter(group=>group.links.length),
  };
}
const dynamicCandidates = [...new Set([
  ...header.flatMap(item=>item.items || [item]), ...groups.flatMap(group=>group.links),
].map(item=>item.href).filter(href=>/^\/(?:use-cases|docs|learn|blog)\//.test(href)))];
module.exports = { header, groups, audiences, legal, isAvailable, projectNavigation, dynamicCandidates };
